import type { ComputedRef } from 'vue';

import { type OrderEntity, type OrderListingEntity, OrderState } from '~/apiClient';

type UseOrderStatusReturn = {
    canEdit: ComputedRef<boolean>;
};

export const useOrderStatus = (order: MaybeRefOrGetter<OrderEntity | OrderListingEntity | undefined>): UseOrderStatusReturn => ({
    canEdit: computed(() => {
        const o = toValue(order);

        return !!o && ![(OrderState.NotPaid, OrderState.Canceled)].includes(o.state);
    }),
});
